import owd from 'owd/owd';

export default class MenuToggle extends owd.Component {
	init() {
        this.isForced = false;
        this.isOpen = false;
        this.$header = $('.header');
        this.$menu = $('.header .menu-secondary');
        this.$menu.wrap('<div class="menu-secondary-wrapper"></div>');
        this.$move = $('.home-intro ul');
        this.$menuWrapper = this.$menu.parent();
        this.$menuWrapper.css({
            display: 'none',
            overflow: 'hidden',
            opacity: 0,
            height: 0
        });
        this.$menu.css({
            display: 'block'
        });

		this.bind();
        this.checkHeight();

        this.$element.data('menuToggleApi', this);
	}

	bind() {

        this.on('click', '.menu-primary .title a, .menu-primary .burger', (e) => {

            if (window.matchMedia('(max-width: 1023px)').matches) {
                e.preventDefault();
                e.stopPropagation();

                if (!this.isForced) {
                    this.toggle();
                }
            }

        });

        this.on('mouseenter mousemove', (e) => {
            e.preventDefault();

            if (!this.isForced && window.matchMedia('(min-width: 1024px)').matches) {
                this.show();
                this.$move.addClass('moved');
            }
        });

        this.on('mouseleave', (e) => {
            e.preventDefault();

            if (!this.isForced && window.matchMedia('(min-width: 1024px)').matches) {
                this.hide();
                this.$move.removeClass('moved');
            }
        });

        this.on('click', $('body'), (e) => {
            if (this.isOpen && !$(e.target).is('.header') && !$(e.target).parents('.header').length) {
                e.preventDefault();

                if (!this.isForced) {
                    this.hide();
                }
            }
        });

        this.on('pageOutDone', this.dom.$window, (e) => {
            if (this.isOpen) {
                this.hide();
            }
        });

        this.on('resize', this.dom.$window, (e) => {
            this.checkHeight();
        });
	}

    show(forced) {
        this.isForced = forced === true;

        if (forced === true) {
            this.$header.addClass('forced-open');
        }

            if (!this.isOpen) {
                this.isOpen = true;
                this.$header.addClass('open');

                if (forced === true) {
                    this.$menuWrapper.css({
                        display: 'block',
                        overflow: 'hidden',
                        height: this.menuHeight,
                        opacity: 0
                    }).stop(true).transition({
                        opacity: 1
                    }, 300, 'easeOutQuad');

                } else {
                    this.$menuWrapper.css({
                        display: 'block',
                        overflow: 'hidden',
                        height: 0,
                        opacity: 0
                    }).stop(true).transition({
                        height: this.menuHeight,
                        opacity: 1
                    }, 300, 'easeOutQuad', () => {
                        if (this.isOpen) {
                            this.$menuWrapper.css({
                                display: 'block'
                            });
                        }
                    });
                }
            }
    }

    hide(forced) {
        if (forced === true) {
            this.isForced = false;

            this.$header.removeClass('forced-open');
        }
        
        if (this.isOpen && !this.isForced) {
            this.isOpen = false;

            this.$menuWrapper.css({
                height: this.menuHeight
            }).stop(true).transition({
                height: 0,
                opacity: 0
            }, 300, 'easeOutQuad', () => {
                if (!this.isOpen) {
                    this.$menuWrapper.css({
                        display: 'none'
                    });
                }
            });

            this.$header.removeClass('open');
        }

    }

    toggle() {
        if (this.isOpen) {
			this.hide();
		} else {
			this.show();
		}
    }

    checkHeight() {
        this.$menuWrapper.stop();

        // if (window.matchMedia('(min-width: 767px)').matches) {
            this.$menuWrapper.css({
                height: '',
                display: 'block'
            });
        // }

        this.menuHeight = this.$menuWrapper.outerHeight();

        if (!this.isOpen) {
            this.$menuWrapper.css({
                display: 'none',
                height: 0
            });
        }
    }

    destroy() {
        super.destroy();

        this.$element.data('menuToggleApi', null);
    }
}

owd.registerComponent('menu-toggle', {
	component: MenuToggle
});
